<template>
    <div class="service-option">
        <ul class="option-list">
            <li
                class="option-item"
                v-for="(item, index) in infoList"
                :class="{'option-active': item.operableUsedFlag == 1 && !cancelOrder, 'van-hairline--bottom': index < (infoList.length-1)}"
                :key="index">
                <div class="item-box">
                    <div class="item-left" @click="checkDetail(item)">
                        <!-- 解决在 vivo X21A ul圆点占据一行的问题-->
                        <ul class="item_ul">
                            <li class="item_ul--li">
                                <div class="item_ul--title">{{item.name}}</div>
                            </li>
                        </ul>
                        <div class="item_time" v-if="item.currentProcess > 0">服务时间：{{item.firstServiceTime | timeToMinute}}</div>
                    </div>
                    <!--operableUsedFlag 是否可操作0:不可操作,1:可操作-->
                    <div v-if="item.operableUsedFlag == 1 && globalFlag == 1" class="item-active">
                        <!-- 0:预约时间 1:开始服务 2:填写护理记录 3:查看护理记录-->
                        <Button @click="appointment(item)" v-if="item.currentProcess == 0"  class="item-btns active" size="mini">预约时间</Button>
                        <Button @click="startService(item)" v-if="item.currentProcess == 1"  class="item-btns active" size="mini">开始服务</Button>
                        <Button @click="finishService(item)" v-if="item.currentProcess == 2" class="item-btns active" size="mini">服务完成</Button>
                        <Button v-if="item.currentProcess == 3" class="item-btns" size="mini">服务完成</Button>
                    </div>
                    <div v-else class="item-active">
                        <!-- 0:预约时间 1:开始服务 2:填写护理记录 3:查看护理记录-->
                        <Button v-if="item.currentProcess == 0"  class="item-btns" size="mini">预约时间</Button>
                        <Button v-if="item.currentProcess == 1"  class="item-btns" size="mini">开始服务</Button>
                        <Button v-if="item.currentProcess == 2" class="item-btns"  size="mini">服务完成</Button>
                        <Button v-if="item.currentProcess == 3" class="item-btns" size="mini">服务完成</Button>
                    </div>
                </div>
            </li>
        </ul>
        <DateTimeLimit
            :show="show"
            :filterFormat="filterMinute"
            :minDate="minDate"
            :maxDate="maxDate"
            @confirmTime="confirmTime"
            @cancel="cancelTime"></DateTimeLimit>
        <ServiceDetails
            :show="showDetail"
            title="服务详情"
            :infos="normsItem"
            @clickClose="close"></ServiceDetails>

    </div>
</template>
<script>
    import { Button,Toast } from 'vant';
    import DateTimeLimit from '@/components/DateTimeLimit/DateTimeLimit.vue'
    import ServiceDetails from '@/components/ServiceDetails/ServiceDetails.vue'
    import { appointmentFirstServiceTime, updateOrderServiceProductStatus } from '@/api/order.js'
    import {getNurseRecordTemplate,getNursingEvaluation,saveNursingEvaluation} from '@/api/nursingEvaluation.js'
    import { arrangeData } from '@/utils/nursingEvaluation.js'
    import { dataBuryingPoint } from '@/utils/JSBridge.js'
    import Moment from 'moment'


    export default {
        props: {
            orderSource: Number,
            cancelOrder: {
                type: Boolean,
                default: false
            },
            infoList: {
                type: Array,
                default: () => []
            },
            globalFlag: Number,
        },
        data() {
            return {
                show: false,
                showDetail: false,
                normsItem: {}, // 选中子规格
            }
        },
        computed: {
            minDate() {
                // 24 小时
                let curDate = new Date();
                let nowDate = curDate.getTime();
                let getMinutes = curDate.getMinutes();
                let supMin = 0;
                if (getMinutes%10 !== 0) {
                    supMin = 10 - getMinutes%10;
                }
                let allTime = nowDate + (supMin * 60 * 1000) + 24 * 60 * 60 * 1000;
                let year = Moment(allTime).year();
                let month = Moment(allTime).month();
                let day = Moment(allTime).date();
                let hour = Moment(allTime).hour();
                let minute = Moment(allTime).minute();
                return new Date(year, month, day, hour, minute);
            },
            maxDate() {
                // 90天
                let nowDate = new Date().getTime();
                let allTime = nowDate + 90 * 24 * 60 * 60 * 1000;
                let year = Moment(allTime).year();
                let month = Moment(allTime).month();
                let day = Moment(allTime).date();
                let hour = Moment(allTime).hour();
                let minute = Moment(allTime).minute();
                return new Date(year, month, day, hour, minute);
            }
        },
        methods: {
            filterMinute(type, options) {
                if (type === 'hour') {
                    return options.filter(option => +option.substring(0, 2) >= 2 && + option.substring(0, 2) <= 22)
                }
                if (type === 'minute') {
                    // 考虑最后9分钟的问题
                    let myOpt = options.filter(option => +option.substring(0, 2) % 10 === 0);
                    return myOpt.length > 0 ? myOpt : options;
                }
                return options;
            },
            startService(item) {
                let params = {serviceOrderId: item.id, serviceOrderStatus: 8};
                updateOrderServiceProductStatus(params).then(r => {
                    let URL = window.location.href;
                    window.location.href = URL;
                }).catch(_ => {});
                dataBuryingPoint('F000017', 'F000017-002', {id: PAGE_PARAMS.orderNo, orderSource: this.orderSource});
            },
            checkDetail(item) {
                if (this.globalFlag == 1) {
                    this.showDetail = true;
                    this.normsItem = item;
                    dataBuryingPoint('C000004', 'C000004-003', {id: PAGE_PARAMS.orderNo, orderSource: this.orderSource});
                }
            },
            close() {
                this.showDetail = false;
                this.normsItem = {};
            },
            cancelTime() {
                this.show = false;
            },
            confirmTime(val) {
                this.show = false;
                appointmentFirstServiceTime({firstServiceTime: val, orderSonNo: this.normsItem.orderSonNo, serviceOrderId: this.normsItem.id}).then(r => {
                    let URL = window.location.href;
                    window.location.href = URL;
                }).catch(_ => {})
            },
            appointment(val) {
                this.normsItem = val;
                this.show = true;
            },
            finishService(item) {
                saveNursingEvaluation({
                    serviceInfoId: item.id, // 子服务id
                }).then(r=>{
                    let URL = window.location.href;
                    window.location.href = URL;
                }).catch(e=>{})
            },
            writeService(item) {
                getNurseRecordTemplate({
                    templateId:item.visitRecord,
                    isFirstService:item.isFirstService
                }).then(r=>{
                    Toast.loading({
                        duration:1000,
                        mask: true,
                        message: '加载中...'
                    });
                    localStorage.setItem('nursingEvaluation',JSON.stringify(arrangeData(r)));
                    setTimeout(_=>{
                        window.location.href = `./nursingEvaluation.html?serviceInfoId=${item.id}&templateId=${item.visitRecord}`
                    },600)
                }).catch(e=>{
                    Toast('填写前请先挂断电话!');
                });
            },
            writeRecord(item) {
                // if (this.globalFlag == 1) {
                //     window.location.href = `./nursingEvaluationDetails.html?serviceInfoId=${item.id}`;
                // }
                if (!item.id) {
                    return;
                }
                window.location.href = `./nursingEvaluationDetails.html?serviceInfoId=${item.id}`;
            }
        },
        filters: {
            timeToMinute(time) {
                return time ? Moment(time).format('YYYY-MM-DD HH:mm') : '';
            }
        },
        created() {
        },
        components: { Button, DateTimeLimit, ServiceDetails }
    }
</script>
<style lang="scss" scoped>
    .service-option {
        .option-list {
            font-size: 17px;
            font-weight: 400;
            color: rgba(34, 34, 34, 1);
            list-style: none;
            padding-left: 30px;
            padding-right: 16px;

            .option-item {
                padding: 16px 0;
                .item-box {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    color: rgba(107, 121, 147, 1);

                    .item-left {
                        .item_ul {
                            list-style: disc;
                            color: rgba(107, 121, 147, 1);
                            &--title {
                                font-size: 17px;
                                font-weight: 400;
                            }
                        }
                        .item_time {
                            padding-top: 6px;
                            font-size: 10px;
                            color: rgba(107, 121, 147, 1);
                        }
                    }

                    .item-active {
                        width: 100px;
                        text-align: right;
                        .item-btns {
                            width: 80px;
                            min-width: 50px;
                            height: 25px;
                            background: #D9E1E8;
                            border-radius: 12px;
                            font-size: 12px;
                            font-weight: 400;
                            color: rgba(255, 255, 255, 1);
                            text-align: center;
                            border: none;
                            &.active {
                                background: #F84025;
                            }
                        }
                    }
                }

                &.option-active {
                    .item-box {
                        .item-left {
                            .item_ul {
                                list-style: disc;
                                &--li {
                                    color: rgba(248, 64, 37, 1);
                                }
                                &--title {
                                    color: rgba(34, 34, 34, 1);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
